// import { SelectOption } from '@/types/form.type.ts';

export enum CarPhotoType {
    FrontLeft = 'front_left',
    RearRight = 'rear_right',
    InteriorFront = 'interior_front',
    InteriorRear = 'interior_rear',
    Left = 'left',
    Right = 'right',
    Dashboard = 'dashboard',
    Trunk = 'trunk',
    Wheel = 'wheel',
    UnderHood = 'under_hood',
    Additional = 'additional',
}

export function getCarPhotoTypeLabel(type: CarPhotoType): string {
    switch (type) {
        case CarPhotoType.FrontLeft:
            return 'Передняя левая часть';
        case CarPhotoType.RearRight:
            return 'Задняя правая часть';
        case CarPhotoType.InteriorFront:
            return 'Салон, передняя часть';
        case CarPhotoType.InteriorRear:
            return 'Второй ряд салона';
        case CarPhotoType.Left:
            return 'Вид слева';
        case CarPhotoType.Right:
            return 'Вид справа';
        case CarPhotoType.Dashboard:
            return 'Приборная панель';
        case CarPhotoType.Trunk:
            return 'Багажник';
        case CarPhotoType.Wheel:
            return 'Колесо';
        case CarPhotoType.UnderHood:
            return 'Под капотом';
        case CarPhotoType.Additional:
            return 'Дополнительная';
    }
}

// export function getCarPhotoTypeSelectOptions(): SelectOption[] {
//     const options: SelectOption[] = [];
//
//     Object.values(CarPhotoType).forEach((type: CarPhotoType) => {
//         options.push({
//             label: getCarPhotoTypeLabel(type),
//             value: type,
//         });
//     });
//
//     return options;
// }
